import React, { useState, useEffect } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import Panel from 'Components/Panel/Panel';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const ExternalCollaboratorControl = ({
    onUpdateResetUserList,
    usersSelected
}) => {
    const [loadingCollaboratorPanel, setLoadingCollaboratorPanel] = useState(null);
    const [sectors, setSectors] = useState([]);

    const [userId, setUserId] = useState(null);
    const [employeeIdSelected, setEmployeeIdSelected] = useState(null);
    const [cpf, setCpf] = useState(null);
    const [sectorSelected, setSectorSelected] = useState(null);
    const [cnpj, setCnpj] = useState(null);
    const [phone, setPhone] = useState(null);
    const [address, setAddress] = useState(null);
    const [complement, setComplement] = useState(null);
    const [addressNumber, setAddressNumber] = useState(null);
    const [neighborhood, setNeighborhood] = useState(null);
    const [city, setCity] = useState(null);
    const [cep, setCep] = useState(null);
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [collaboratorListAttributes, setCollaboratorListAttributes] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const readOnlyAttributes = !(inserting || updating);

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };
        fetchData()

    }, []);

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true);

    const attributeList = [
        { name: "id", value: employeeIdSelected, setter: setEmployeeIdSelected },
        { name: "cpf", value: cpf, setter: setCpf },
        { name: "cnpj", value: cnpj, setter: setCnpj },
        { name: "phone", value: phone, setter: setPhone },
        { name: "sectorId", value: sectorSelected, setter: setSectorSelected, comboboxOptions: sectorOptions },
        { name: "address", value: address, setter: setAddress },
        { name: "addressNumber", value: addressNumber, setter: setAddressNumber },
        { name: "neighborhood", value: neighborhood, setter: setNeighborhood },
        { name: "complement", value: complement, setter: setComplement },
        { name: "city", value: city, setter: setCity },
        { name: "cep", value: cep, setter: setCep },
        { name: "username", value: username, setter: setUsername, readOnly: true },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: true }
    ];

    const setEmployeeAttributes = async (userId) => {
        const parameters = { userId: userId }
        const employee = await ExecuteAxios.api('get', `/external-employee/detail/`, { params: parameters });
        if (employee) {
            setCollaboratorListAttributes(employee)
            ApplyAttributes.applyAttributes(employee, attributeList)
        }

        if (!employee || !employee[0] || !employee[0].id) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (usersSelected.length === 1) {
            setEmployeeAttributes(usersSelected[0]);
        } else {
            setEmployeeAttributes(null);
        }
    }, [usersSelected, inserting, updating]);

    async function updateRoleControlEmployee() {
        try {
            setLoadingCollaboratorPanel(true)
            const response = await ExecuteAxios.api('put', '/external-employee/',
                {
                    id: employeeIdSelected,
                    cpf: cpf,
                    cnpj: cnpj,
                    sectorId: sectorSelected,
                    phone: phone,
                    address: address,
                    addressNumber: addressNumber,
                    neighborhood: neighborhood,
                    complement: complement,
                    city: city,
                    cep: cep
                });

            if (response) {
                onUpdateResetUserList(true)
            }

            return response;
        } finally {
            setLoadingCollaboratorPanel(false)
        }
    }

    async function newRoleControlEmployee() {
        try {
            setLoadingCollaboratorPanel(true)
            const response = await ExecuteAxios.api('post', '/external-employee/',
                {
                    userId: usersSelected[0],
                    cpf: cpf,
                    cnpj: cnpj,
                    sectorId: sectorSelected,
                    phone: phone,
                    address: address,
                    addressNumber: addressNumber,
                    neighborhood: neighborhood,
                    complement: complement,
                    city: city,
                    cep: cep
                });

            if (response) {
                onUpdateResetUserList(true);
            }
            return response
        } finally {
            setLoadingCollaboratorPanel(false)
        }
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        zIndex: '1000',
        borderBottom: '2px solid rgb(204, 204, 204)'
    };

    return (
        <Panel
            style={userControlPanelStyle}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={usersSelected.length === 1 && employeeIdSelected}
            putFunction={updateRoleControlEmployee}
            enableNewRecord={true}
            canNewRecord={usersSelected.length === 1 && !employeeIdSelected}
            postFunction={newRoleControlEmployee}
            canViewCRUD={true}
            readOnly={!(usersSelected && usersSelected.length === 1)}
            recordsSelected={usersSelected}
            viewOnlyOneRecordCRUD={true}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={collaboratorListAttributes}
            attributeList={attributeList}
        >
            <>
                <LoadingIndicator loaded={!loadingCollaboratorPanel}>
                    <AutomaticallyListedAttributes
                        list={collaboratorListAttributes}
                        attributeList={attributeList}
                        readOnlyAttributes={readOnlyAttributes}
                    />
                </LoadingIndicator>
            </>
        </Panel>
    );
};

export default ExternalCollaboratorControl;